import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
// import useSalesTeamAPI from '../apis/salesTeamAPI';
import EventEmitter from '../../utils/eventEmitter';
import usePosAPI from '../apis/posAPI';



const PosChanges = () => {
  const { pos, deliveryRegions, employees, paymentMethods, salesTeams, operationTypes, journals } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(pos.name ? pos.name : '');
  const { create, update, addPaymentmethod, removePaymentmethod, addEmployee, removeEmployee } = usePosAPI();


  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
    // console.log(data);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['id'] = pos.id;
    // data['payment_methods'].forEach(method => {
    //   if ()
    // })
    update(pos.seo, data, success);
    // console.log(data)
  };

  const handleAddPaymentMethod = (value) => {
    let data = {id: pos.id, payment_id: value};
    if (data.id) addPaymentmethod(data);
  }

  const handleRemovePaymentMethod = (value) => {
    let data = {id: pos.id, payment_id: value};
    if (data.id) removePaymentmethod(data);
  }

  const handleAddEmployee = (value) => {
    let data = {id: pos.id,employee_id: value};
    if (data.id) addEmployee(data);
  }

  const handleRemoveEmployee = (value) => {
    let data = {id: pos.id,employee_id: value};
    if (data.id) removeEmployee(data);
  }

  useEffect(() => {
    EventEmitter.subscribe('pos_response', data => {
      navigate('/pos/point-of-sales/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('pos_response');
    }
  },[])
  // console.log(operationTypes)

  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/pos/point-of-sales'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Point of Sales</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ pos.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {pos.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Point of Sale Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={pos.seo ? 
            {
              ...pos, 
              payment_methods: pos.pos_pospaymentmethods.map(method => method.payment_method_id),
              employees: pos.cashiers.map(employee => employee.employee_id)
            } : 
            {}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item labelCol={{md: {span: 10}}} label='Authorized Employees' name='employees' className='font-semibold text-gray-800 mb-4' >
                <Select mode='tags' options={employees.map(employee => ({value: employee.id, label: employee.name}))} onSelect={(value) => handleAddEmployee(value)} onDeselect={value => handleRemoveEmployee(value)}/>
              </Form.Item>
            </Col>
            <Col md={{span: 10, offset: 1}}>
              <Form.Item labelCol={{md: {span: 5}}} label='Hotline' name='phone' className='font-semibold text-gray-800 mb-4' >
                <Input type='tel' placeholder='0123456789' maxLength={10} className='input-outline-none font-normal' />
              </Form.Item>
            </Col>
          </Row>
          
          <Badge className="text-slate-500 w-1/2 text-sm bg-transparent	border-b-2 mb-3 ">POS INTERFACE</Badge>
          <Col md={{span: 11}}>
            <Form.Item labelCol={{md: {span: 10}}} label='Delivery Region' name='delivery_region_id' className='font-semibold text-gray-800 mb-4' >
              <Select options={deliveryRegions.map(region => ({value: region.id, label: region.name}))}/>
            </Form.Item>
          </Col>

          <Badge className="text-slate-500 w-1/2 text-sm bg-transparent	border-b-2 mb-3 ">PAYMENTS</Badge>
          <Col md={{span: 11}}>
            <Form.Item labelCol={{md: {span: 10}}} label='Payment Methods' name='payment_methods' className='font-semibold text-gray-800 mb-4' >
              <Select mode='tags' options={paymentMethods.map(payment => ({value: payment.id, label: payment.name}))} onSelect={(value) => handleAddPaymentMethod(value)} onDeselect={value => handleRemovePaymentMethod(value)}/>
            </Form.Item>
          </Col>


          <Badge className="text-slate-500 w-1/2 text-sm bg-transparent	border-b-2 mb-3 ">BILLS & RECEIPTS</Badge>
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Invoice Journal' name='invoice_journal_id' className='font-semibold text-gray-800 mb-4' >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))}/>
              </Form.Item>
            </Col>
            <Col md={{span: 10, offset: 1}}>
              <Form.Item labelCol={{md: {span: 10}}} label='Automatic Receipt Printing' name='automatic_receipt_printing' className='font-semibold text-gray-800 mb-4' valuePropName='checked' >
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>

          <Badge className="text-slate-500 w-1/2 text-sm bg-transparent	border-b-2 mb-3 ">INVENTORY</Badge> 
          <Row>  
            <Col md={{span: 11}}>
              <Form.Item label='Operation Type' name='operation_type_id' className='font-semibold text-gray-800 mb-4' >
                <Select options={operationTypes.map(operation => ({value: operation.id, label: `${operation.short_name}: ${operation.name}`}))}/>
              </Form.Item>
              <Form.Item label='Location' className='font-semibold text-gray-800 mb-4' >
                <Input readOnly className='input-outline-none'/>
              </Form.Item>
            </Col>
          </Row>

          <Badge className="text-slate-500 w-1/2 text-sm bg-transparent	border-b-2 mb-3 ">ACCOUNTING</Badge>
          <Row>
            <Col md={{span: 11}}>
              <Badge className="text-slate-500 w-1/2 text-sm bg-transparent ">Journal Entries</Badge> 
              <p className='text-gray-500 p-0'>Configurations for journal entries of PoS orders</p>
              <Form.Item label='Sales journal' name='sales_journal_id' className='font-semibold text-gray-800 mb-4' >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))}/>
              </Form.Item>
            </Col>
          </Row>

          <Badge className="text-slate-500 w-1/2 text-sm bg-transparent	border-b-2 mb-3 ">SALES REPORTING</Badge>
          <Row>
            <Col md={{span: 11}}>
              <Badge className="text-slate-500 w-1/2 text-sm bg-transparent ">Sales Team</Badge> 
              <p className='text-gray-500 p-0'>Sales are reported to the following sales team</p>
              <Form.Item label='Sales Team' name='sales_team_id' className='font-semibold text-gray-800 mb-4' >
                <Select options={salesTeams.map(team => ({value: team.id, label: team.name}))}/>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  )
}

export default PosChanges;